<template>
  <div id="main-language-div">
    <v-select
      v-model="selectedLanguage"
      :options="selectableLanguages"
      :clearable="false"
      :searchable="false"
      label="title"
      name="select_country"
    >
      <template slot="selected-option" slot-scope="option">
        <img class="mr-2 select-icon-width" :src="option.icon" alt="" />
        {{ option.title }}
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-flex align-items-center">
          <img class="mr-1 select-icon-width" :src="option.icon" alt="" />
          {{ option.title }}
        </div>
      </template>
      <span slot="no-options">{{ $t('Üzgünüz belirtmiş olduğunuz seçenek bulunamadı') }}</span>
    </v-select>
  </div>
</template>

<script>
export default {
  inject: ['openRedirectModal', 'redirectModalState'],
  data() {
    return {
      selectedLanguageValue: null,
    };
  },
  created() {
    this.createTestFunctions();
    const lang = this.$route.query.lang;
    const validLang = this.selectableLanguages.find((x) => x.value === lang);

    if (validLang) {
      this.selectedLanguageValue = validLang;
      this.$i18n.locale = validLang.value;
    } else {
      this.selectedLanguageValue =
        this.selectableLanguages.find((x) => x.value === this.$i18n.locale) ||
        this.selectableLanguages.find((x) => x.value === 'en');
      this.$i18n.locale = this.selectedLanguageValue.value;
    }
  },
  methods: {
    createTestFunctions() {
      this.selectLanguage();
    },
  },
  computed: {
    selectedLanguage: {
      get: function () {
        return this.selectedLanguageValue;
      },
      set: function (event) {
        console.log('evet', event);
        this.selectedLanguageValue = event;
        if (this.isWebsiteMukellef) {
          this.openRedirectModal();
        } else {
          localStorage.setItem('lang', event.value);
          this.$i18n.locale = event.value;
        }

        /* window.document.getElementById('redirectModal').click();
        const seconds = this.$refs.redirectModal.seconds * 1000;
        let timer = this.$refs.redirectModal.seconds;
        const sec = window.document.getElementById('redirect-seconds');

        window.setInterval(() => {
          sec.innerHTML = timer;
          timer--;
        }, 1000);


        window.setTimeout(() => this.$refs.redirectModal.redirect(), seconds); */
        /* let lang = '/' + event.value;

        if (lang === '/tr') {
          lang = '';
        }
        let queryString = '';
        for (const [k, v] of Object.entries(this.$route.query)) {
          queryString += queryString ? '&' : '?';
          if (k != 'step') queryString += k.toString() + '=' + v.toString();
          else queryString += k.toString() + '=1';
        }
        const path = this.$route.path;
        const isLanguageOther = path.includes('/' + this.$i18n.locale + '/');
        let currentPathWithoutLanguage;
        if (isLanguageOther) {
          currentPathWithoutLanguage = path.split('/' + this.$i18n.locale + '/')[1];
        } else {
          currentPathWithoutLanguage = path.substring(1);
        }
        localStorage.setItem('lang', event.value);
        this.$i18n.locale = event.value;
        /* if (this.getToken().access_token && this.$store.state.selfMeData && this.$store.state.selfMeData.lang) {
          $axios.put('self/lang', { lang: event.value }).then((s) => {
            this.endWaiting();
            this.$router.push({
              path: `${lang}/${currentPathWithoutLanguage}${queryString}`,
            });
          });
        } else { */
        /* this.$router.push({
          path: `${lang}/${currentPathWithoutLanguage}${queryString}`,
        }); */
        // }
      },
    },
    selectableLanguages() {
      const selectableLanguageData = [];
      if (this.isWebsiteMukellef || this.$route.path === '/connect') {
        selectableLanguageData.push({
          title: 'Türkçe',
          value: 'tr',
          icon: '/img/icons/TR.svg',
        });
      }

      selectableLanguageData.push({
        title: 'English',
        value: 'en',
        icon: '/img/icons/UK.svg',
      });

      if (!this.isWebsiteMukellef) {
        selectableLanguageData.push({
          title: 'Português',
          value: 'pt',
          icon: '/img/icons/PT.svg',
        });
      }
      return selectableLanguageData;
    },
  },
  watch: {
    redirectModalState: function (val) {
      if (!val) {
        this.selectedLanguage = this.selectableLanguages.find((x) => x.value === this.$i18n.locale);
        // if (this.isWebsiteMukellef) {
        //   alert('redirect girdi');

        //   this.selectedLanguage = this.selectableLanguages.find((x) => x.value === 'tr');
        // } else {
        //   alert('redirect else girdi');
        //   this.selectedLanguage = this.selectableLanguages.find((x) => x.value === 'en');
        // }
      }
    },
  },
};
</script>

<style lang="less">
.language-select {
  height: 30px;
  padding: 0px 30px 0px 5px;
  border-radius: 3px;
  cursor: pointer;
  background: transparent
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%23aaaaaa' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
    right 0.75rem center/8px 10px no-repeat;
}

#main-language-div {
  width: 155px;
  margin-left: auto;

  .dropdown-menu {
    min-width: 135px !important;
  }
}
</style>
